/**
 * Where the console talks to Habitat Admin.
 *
 * Baked into the bundle at build time via `VITE_HA_SERVER_URL`. Every
 * instance builds the app when it boots, so an unset variable is not
 * caught until someone tries to sign in — and without this it fails
 * as a fetch to `undefined/v2/staff/login`, which looks like any
 * other network fault. Callers gate on `null` and say plainly that
 * the console is misconfigured rather than leaving whoever hit it to
 * guess.
 *
 * In dev it falls back to the usual local port so the local rig works
 * with no extra config, matching `resolveHlAccountsBaseUrl`.
 */

/**
 * The code is there so whoever is told about it can be searched for
 * in here and land on this file. The variable itself is deliberately
 * not named on screen — it means nothing to the person reading it and
 * says more about our setup than a login page should.
 */
export const HA_SERVER_UNCONFIGURED_MESSAGE =
    'This console cannot reach Habitat Admin. Tell an engineer and quote HA-CONFIG-01.'

export function resolveHaServerUrl(): string | null {
    const configured = import.meta.env.VITE_HA_SERVER_URL
    if (configured) return configured
    return import.meta.env.DEV ? 'http://localhost:3001' : null
}
